var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpandHandle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h34v34H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M32 .879V32H.878z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DFDFDF",
  fillRule: "nonzero",
  d: "M32 3v29H3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.999 21.441v2.474L23.914 29H21.44l7.559-7.559zM29 12.955v2.473L15.428 29h-2.473L29 12.955z",
  fill: "#545454"
}))));
export default SvgExpandHandle;